import * as React from "react";
import { LoadingContainer } from "./styles";

interface LoadingProps {
	style?: React.CSSProperties;
}

class Loading extends React.Component<LoadingProps> {
	render() {
		const { style = {} } = this.props;
		return (
			<LoadingContainer style={style}>
				<span />
				<span />
				<span />
			</LoadingContainer>
		);
	}
}

export default Loading;
